export default "__VITE_PUBLIC_ASSET__027f482f__"